import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { ReportTemplateTypeEnum } from '../enums/report-template-type.enum';

/**
 * Report template DTO for lists
 */
@CaslSubject(AppSubjectEnum.REPORT_TEMPLATE)
export class ReportTemplateListDto extends BaseDto {
	name!: string;
	description?: string;
	type!: ReportTemplateTypeEnum;
	tags?: TagListDto[];

	mobileTitle = (): string => {
		return `${this.name}`;
	};

	mobileSubtitle = (): string => {
		return `${this.description}`;
	};
}
